import './catheadsdiner/style';
import FormStructure from './catheadsdiner/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/Dev/web_inquiry/inquiry-renderer/client_forms/includes.js